import { render, staticRenderFns } from "./doctor-list-for-dashboard.html?vue&type=template&id=38779482&scoped=true&external"
import script from "./doctor-list-for-dashboard.js?vue&type=script&lang=js&external"
export * from "./doctor-list-for-dashboard.js?vue&type=script&lang=js&external"
import style0 from "./doctor-list-for-dashboard.scss?vue&type=style&index=0&id=38779482&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38779482",
  null
  
)

export default component.exports